import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import tracking from '../../utils/tracking';
import i18n from 'kodyl-js/i18n/react';
import Form from './form';
import SplashBox from './splash-box';
import LastDwelling from '../../common/last-dwelling';
import { event } from '../../redux/modules/app';

@connect(
  () => ({}),
  { event }
)
@i18n
class CreateSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offer: null
    };

    if (props.offers.length) {
      this.offerVisible(props.offers[0]);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.offers.length && nextProps.offers.length) {
      this.offerVisible(nextProps.offers[0]);
    }
  }

  offerVisible(offer) {
    this.props.event({
      action: 'subscription/splash',
      data: { offer: offer.name }
    });
    tracking.page(`/profile/subscription/${offer.name}/splash`, offer.name);
  }

  offerOnClick(offer) {
    return () => {
      this.props.event({
        action: 'subscription/payment-form',
        data: { offer: offer.name }
      });
      tracking.page(`/profile/subscription/${offer.name}/payment`, offer.name);

      this.setState({ offer }, () => {
        if (__CLIENT__) {
          window.scrollTo(0, 0);
        }
      });
    };
  }

  render() {
    const { offer } = this.state;
    const { offers } = this.props;

    if (offer) {
      return <Form offer={offer} />;
    }

    return (
      <Row>
        <Col xs={12}>
          <LastDwelling page="subscription" />
        </Col>
        {offers.map(offer => (
          <Col key={offer.name} xs={12}>
            {/* <h1>{ this.i18n('Access to all landlords with %s', this.i18n(offer.labels.product)) }</h1> */}
            <h1>Få adgang til alt!</h1>
            <SplashBox onClick={this.offerOnClick(offer)} offer={offer} />
          </Col>
        ))}
      </Row>
    );
  }
}

export default CreateSubscription;
